// extracted by mini-css-extract-plugin
module.exports = {"list-view-paginated":"list-view-paginated__list-view-paginated___iF1VL","overlay":"list-view-paginated__overlay___Rjcyn"};